t<template>
  <div
    class="monitor"
    style="font-size: 16px; width: 100%; background: #eff1f5"
  >
    <div class="content">
      <div class="yuliang" ref="yuliang" style="margin-top: 0">
        <div class="select clearfix" ref="districtrainOperation">
          <span class="desc">时间选择:</span>
          <div style="display: inline-block">
            <el-date-picker
              v-model='queryTime'
              value-format="yyyy-MM-dd HH:mm"
              format="yyyy-MM-dd HH:mm"
              type="datetime"
              placeholder="选择开始时间"
              :clearable="false"
              @change="getChangeTimeData"
            ></el-date-picker>
          <!-- <el-radio-group v-model="chooseQueryTime" @change="getChangeTimeData">
            <el-radio :label="0" :disabled ="disabledYes">昨日</el-radio>
            <el-radio :label="1" :disabled ="disabledToday">今日</el-radio>
          </el-radio-group> -->
          </div>
         <!-- <span id="select" @click="searchData">查询</span> -->
          <span id="export" @click="exportDocx">
            <span class="export-icon" ref="downloadArea"></span>导出
          </span>
        </div>
        <div class="tableDiv" ref="tableDiv" v-loading = "loading">
          <div class='tinymce' style="width:100%;height:100%">
          <editor id='tinymce' v-model='tinymceHtml' :init="init"></editor>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import htmlDocx from 'html-docx-js/dist/html-docx' // html转word
import saveAs from 'file-saver'
import tinymce from 'tinymce/tinymce.min.js'
// import 'tinymce/themes/silver/theme'
import Editor from '@tinymce/tinymce-vue'
import 'tinymce/themes/silver'
import 'tinymce/plugins/image'
import 'tinymce/plugins/link'
import 'tinymce/plugins/code'
import 'tinymce/plugins/table'
import 'tinymce/plugins/lists'
import 'tinymce/plugins/contextmenu'
import 'tinymce/plugins/wordcount'
import 'tinymce/plugins/colorpicker'
import 'tinymce/plugins/textcolor'
import 'tinymce/plugins/print'
import 'tinymce/icons/default/icons'
import reportAnalysisTypes from '@/store/types/reportAnalysis'
export default {
  name: 'tinymce',
  data () {
    return {
      loading: true,
      query: {
        addvcd: '330324',
        begTime: '',
        endTime: ''
      },
      queryTime: '',
      chooseQueryTime: '',
      disabledYes: false,
      disabledToday: false,
      currentYear: '',
      countyAverageRain: 0,
      reservoirStorage: [
        { content: '总体情况', type: '总体情况', name: '水情', warnValue: '1336.27', value: '1093.16' }
      ],
      tinymceHeight: 700,
      tdata: [],
      tinymceHtml: '', // 富文本内容
      showTrData: '',
      tableFrame: '',
      showTime: '',
      titleTime: '',
      riverList: [], // 水位情况
      nextText: [], // 下一步措施
      nextTextFrame: '',
      rainInfo: [], // 降雨情况
      rainInfoFrame: '',
      riverInfo: [], // 江河水情
      riverInfoFrame: '',
      reservoirInfo: '', // 水库水情
      reservoirInfoFrame: '',
      reservoirList: '', // 水库列表
      reservoirListFrame: '',
      townList: [], // 各乡镇列表(降雨情况)
      townListFrameLeft: '',
      townListFrameRight: '',
      riverListFrameLeft: '',
      riverListFrameRight: '',
      init: {
        selector: '.tinymce',
        language_url: 'tinymce/zh_CN.js',
        language: 'zh_CN',
        skin_url: 'tinymce/skins/ui/oxide', // 皮肤引入错误可能不显示
        content_css: 'tinymce/water_rain_daily.css', // 内联模式引入css
        auto_focus: false,
        height: '100%',
        plugins: 'print link lists image code table colorpicker textcolor wordcount contextmenu',
        toolbar:
          'print bold italic underline strikethrough | fontsizeselect | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent blockquote | undo redo | link unlink image code | removeformat',
        branding: false,
        inline: false
        // menubar: false
      },
      smallReservoirList: [], // 小型水库
      smallReservoirFrame: '',
      middleReservoirList: [], // 中型水库
      middleReservoirFrame: '',
      totalReservoirList: [], // 大型水库
      totalReservoirFrame: '',
      waterLevelLength: null,
      tableLength: null
    }
  },
  components: {
    Editor
  },
  methods: {
    getChangeTimeData () { // 时间切换
      let nowdate = new Date()
      let year = nowdate.getFullYear()
      let month = nowdate.getMonth()
      let day = nowdate.getDate()
      // let hh = nowdate.getHours()
      const nowQueryTime = `${year}-${month + 1}-${day}`
      // 当前选中时间判断
      let chooseYear = this.$moment(this.queryTime).year()
      let chooseMonth = this.$moment(this.queryTime).month()
      let chooseDay = this.$moment(this.queryTime).date()
      let choosehh = this.$moment(this.queryTime).hour()
      const chooseQueryTime = `${chooseYear}-${chooseMonth + 1}-${chooseDay}`
      // console.log(this.$moment(this.queryTime).toDate().getTime())
      if (nowQueryTime === chooseQueryTime) { // 今天
        if (choosehh >= 9) {
          this.titleTime = chooseYear + '年' + (chooseMonth + 1) + '月' + chooseDay + '日'
          this.query.begTime = this.$moment(this.queryTime).format('YYYY-MM-DD 00:00')
          this.query.endTime = this.$moment(this.queryTime).format('YYYY-MM-DD HH:mm')
        } else {
          let preDate = new Date(this.$moment(this.queryTime).toDate().getTime() - 24 * 60 * 60 * 1000)
          this.titleTime = preDate.getFullYear() + '年' + (preDate.getMonth() + 1) + '月' + preDate.getDate() + '日'
          this.query.begTime = this.$moment(preDate).format('YYYY-MM-DD 00:00')
          this.query.endTime = this.$moment(this.queryTime).format('YYYY-MM-DD 00:00')
        }
      } else { // 不是当天，今天时间之前
        if (choosehh >= 9) {
          this.titleTime = chooseYear + '年' + (chooseMonth + 1) + '月' + chooseDay + '日'
          this.query.begTime = this.$moment(this.queryTime).format('YYYY-MM-DD 00:00')
          this.query.endTime = this.$moment(this.queryTime).format('YYYY-MM-DD HH:mm')
        } else {
          let preDate = new Date(this.$moment(this.queryTime).toDate().getTime() - 24 * 60 * 60 * 1000)
          this.titleTime = preDate.getFullYear() + '年' + (preDate.getMonth() + 1) + '月' + preDate.getDate() + '日'
          this.query.begTime = this.$moment(preDate).format('YYYY-MM-DD 00:00')
          this.query.endTime = this.$moment(this.queryTime).format('YYYY-MM-DD 00:00')
        }
      }
      this.searchData()
    },
    chooseTime () { // 默认选择时间
      let nowdate = new Date()
      let hh = nowdate.getHours()
      this.queryTime = this.$moment(nowdate).format('YYYY-MM-DD HH:00')
      if (hh >= 9) {
        this.titleTime = nowdate.getFullYear() + '年' + (nowdate.getMonth() + 1) + '月' + nowdate.getDate() + '日'
        this.query.begTime = this.$moment(nowdate).format('YYYY-MM-DD 00:00')
        this.query.endTime = this.$moment(nowdate).format('YYYY-MM-DD HH:00')
      } else {
        let preDate = new Date(nowdate.getTime() - 24 * 60 * 60 * 1000)
        this.titleTime = preDate.getFullYear() + '年' + (preDate.getMonth() + 1) + '月' + preDate.getDate() + '日'
        this.query.begTime = this.$moment(preDate).format('YYYY-MM-DD 00:00')
        this.query.endTime = this.$moment(nowdate).format('YYYY-MM-DD 00:00')
      }
    },
    // getChangeTimeData () { // 昨日今日切换
    //   let nowdate = new Date()
    //   if (this.chooseQueryTime === 1) {
    //     this.titleTime = nowdate.getFullYear() + '年' + (nowdate.getMonth() + 1) + '月' + nowdate.getDate() + '日'
    //     this.query.begTime = this.$moment(nowdate).format('YYYY-MM-DD 00:00')
    //     this.query.endTime = this.$moment(nowdate).format('YYYY-MM-DD HH:mm')
    //   } else {
    //     let preDate = new Date(nowdate.getTime() - 24 * 60 * 60 * 1000)
    //     this.titleTime = preDate.getFullYear() + '年' + (preDate.getMonth() + 1) + '月' + preDate.getDate() + '日'
    //     this.query.begTime = this.$moment(preDate).format('YYYY-MM-DD 00:00')
    //     this.query.endTime = this.$moment(nowdate).format('YYYY-MM-DD 00:00')
    //   }
    //   this.searchData()
    // },
    // chooseTime () { // 默认选择时间
    //   let nowdate = new Date()
    //   let hh = nowdate.getHours()
    //   if (hh >= 9) {
    //     this.chooseQueryTime = 1
    //     this.titleTime = nowdate.getFullYear() + '年' + (nowdate.getMonth() + 1) + '月' + nowdate.getDate() + '日'
    //     this.query.begTime = this.$moment(nowdate).format('YYYY-MM-DD 00:00')
    //     this.query.endTime = this.$moment(nowdate).format('YYYY-MM-DD HH:mm')
    //   } else {
    //     let preDate = new Date(nowdate.getTime() - 24 * 60 * 60 * 1000)
    //     this.chooseQueryTime = 0
    //     this.disabledToday = true
    //     this.titleTime = preDate.getFullYear() + '年' + (preDate.getMonth() + 1) + '月' + preDate.getDate() + '日'
    //     this.query.begTime = this.$moment(preDate).format('YYYY-MM-DD 00:00')
    //     this.query.endTime = this.$moment(nowdate).format('YYYY-MM-DD 00:00')
    //   }
    // },
    searchData () {
      // 查询后拼接字符串覆盖为空
      this.nextTextFrame = ''
      this.rainInfoFrame = ''
      this.townListFrameLeft = ''
      this.townListFrameRight = ''
      this.riverListFrameLeft = ''
      this.riverListFrameRight = ''
      this.reservoirInfoFrame = ''
      this.reservoirListFrame = ''
      this.smallReservoirFrame = ''
      this.middleReservoirFrame = ''
      this.totalReservoirFrame = ''
      this.tabledata()
      // this.getChangeTime()
    },
    getShowDataTr () { // 富文本内页面拼接
      this.tinymceHtml = ` 
      <p style="margin: 12px auto 0; display: block; text-align: center; font-weight: bold; font-size: 24pt; color: #f60;">永嘉县水雨情日报</p>
      <p style="margin: 10px auto 0; display: block; text-align: center; font-size: 18pt; font-weight: bold;">(${this.currentYear}年第xx期)</p>
      <p style="border-bottom: 2px solid #f60; padding-bottom: 7px;"><span style="margin-left: 14pt; font-size: 14pt; font-weight: 500; color: #f60;">永嘉县水利局</span><span style="float: right; margin-right: 14pt; font-size: 14pt; font-weight: 500; color: #333;">${this.titleTime}</span></p>
      <p style="padding: 8px; font-size: 16pt; font-weight: bold; margin-top: 30px;">一、降雨情况</p>
      <div style="overflow:hidden;width：100%;">
        <div  style="width:50%;float:left;box-sizing:border-box">
          <table style="width:100%; border-collapse: collapse; margin-top: 10px;">
            <tbody class="tb1">
              <tr class="firstRow" style="background: #b0c0d5;">
              <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 14pt; border: 1px solid #ccc;">序号</td>
              <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 14pt; border: 1px solid #ccc;">乡镇(街道)</td>
              <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 14pt; border: 1px solid #ccc;">最大雨量站点(mm)</td>
              <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 14pt; border: 1px solid #ccc;">面平均雨量(mm)</td>
              </tr>
              <tr style="background: white;">
              ${this.townListFrameLeft}
              </tr>
          </tbody>
          </table>
        </div>
        <div  style="width:50%;float:right;box-sizing:border-box">
           <table style="width: 100%; border-collapse: collapse; margin-top: 10px;">
              <tbody class="tb1">
                <tr class="firstRow" style="background: #b0c0d5;">
                <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 14pt; border: 1px solid #ccc;">序号</td>
                <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 14pt; border: 1px solid #ccc;">乡镇(街道)</td>
                <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 14pt; border: 1px solid #ccc;">最大雨量站点(mm)</td>
                <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 14pt; border: 1px solid #ccc;">面平均雨量(mm)</td>
                </tr>
                <tr style="background: white;">
                ${this.townListFrameRight}
                </tr>
              </tbody>
            </table>
        </div>
      </div>
      <div>
       <table style="width: 100%; border-collapse: collapse;">
          <tbody class="tb1">
          <tr style="background: white;">
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 14pt; border: 1px solid #ccc;">县平均雨量(mm):${this.countyAverageRain}</td>
          </tr>
          </tbody>
      </table>
      </div>
       <p style="padding: 8px; font-size: 16pt; font-weight: bold; margin-top: 30px;">二、水位情况</p>
      <div style="overflow:hidden">
        <div style="width:50%;float:left;box-sizing:border-box">
          <table style="width: 100%; border-collapse: collapse; margin-top: 10px;">
            <tbody class="tb1">
              <tr class="firstRow" style="background: #b0c0d5;">
              <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 14pt; border: 1px solid #ccc;">站名</td>
              <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 14pt; border: 1px solid #ccc;">水位(m)</td>
              <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 14pt; border: 1px solid #ccc;">逐日变化幅度(m)</td>
              <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 14pt; border: 1px solid #ccc;">超警戒水位(m)</td>
              </tr>
              <tr style="background: white;">
              ${this.riverListFrameLeft}
              </tr>
          </tbody>
          </table>
        </div>
        <div style="width:50%;float:right;box-sizing:border-box">
           <table style="width: 100%; border-collapse: collapse; margin-top: 10px;">
              <tbody class="tb1">
                <tr class="firstRow" style="background: #b0c0d5;">
                <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 14pt; border: 1px solid #ccc;">站名</td>
                <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 14pt; border: 1px solid #ccc;">水位(m)</td>
                <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 14pt; border: 1px solid #ccc;">逐日变化幅度(m)</td>
                <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 14pt; border: 1px solid #ccc;">超警戒水位(m)</td>
                </tr>
                <tr style="background: white;">
                ${this.riverListFrameRight}
                </tr>
              </tbody>
            </table>
        </div>
      </div>
      <p style="padding: 8px; font-size: 16pt; font-weight: bold; margin-top: 30px;">三、水库蓄水情况</p>
       <div style="width:100%;float:right;box-sizing:border-box;margin-bottom:20px">
           <table style="width: 100%; border-collapse: collapse; margin-top: 10px;">
              <tbody class="tb1">
               <tr class="firstRow" style="background: #b0c0d5;">
                <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 14pt; border: 1px solid #ccc;">类型</td>
                <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 14pt; border: 1px solid #ccc;" colspan="3" rowspan="1">水情指标</td>
                <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 14pt; border: 1px solid #ccc;">当前</td>
                <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 14pt; border: 1px solid #ccc;">汛限</td>
               </tr>
                ${this.smallReservoirFrame}
                ${this.middleReservoirFrame}
                ${this.totalReservoirFrame}
                </tbody>
            </table>
        </div>
      <p style="padding: 8px; font-size: 16pt; font-weight: bold; margin-top:30px;">四、水雨情分析</p>
      <p style="font-size: 14pt; margin-top: -5px; text-indent: 25px;">1、${this.rainInfo}</p>
      <p style="font-size: 14pt; margin-top: -5px; text-indent: 25px;"> <span>2、</span><span>${this.reservoirInfo}</span></p>
      <p style="font-size: 14pt; margin-top: -5px; text-indent: 25px;">3、${this.riverInfo}</p>
      <p style="padding: 8px; font-weight: 500; font-weight: bold;margin-top: 30px; font-size: 16pt;">五、建议</p>
      ${this.nextTextFrame}    
    `
    },
    tabledata () {
      this.loading = true
      this.$store
        .dispatch(reportAnalysisTypes.WATER_RAIN_DAILY, {
          begTime: this.query.begTime,
          endTime: this.query.endTime
        })
        .then(data => {
          if (data.result === 'Success') {
            this.countyAverageRain = data.data.totalAvg
            this.nextText = data.data.nextText
            this.rainInfo = data.data.rainInfo
            this.riverInfo = data.data.riverInfo
            this.townList = data.data.townList
            this.reservoirInfo = data.data.reservoirInfo.toString()
            this.reservoirList = data.data.reservoirList
            this.riverList = data.data.riverList
            this.totalReservoirList = data.data.totalReservoirList
            this.middleReservoirList = data.data.middleReservoirList
            this.smallReservoirList = data.data.smallReservoirList
            // 降雨情况,各镇降雨量表格拼接
            if (this.townList.length % 2 === 0) {
              this.tableLength = this.townList.length / 2
            } else {
              this.tableLength = Math.ceil(this.townList.length / 2)
            }
            this.townList.slice(0, this.tableLength).forEach((el, index) => { // 截取表格前半部分
              this.townListFrameLeft += `
            <tr >
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${index + 1}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${!el.townName ? '/' : el.townName}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${!el.stationInfo || el.stationInfo.indexOf('null') !== -1 ? '/' : el.stationInfo}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${!el.value ? '0' : el.value}</td>
            </tr>
            `
            })
            this.townList.slice(this.tableLength, this.tableLength * 2).forEach((el, index) => { // 截取表格后半部分
              this.townListFrameRight += `
               <tr>
                <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${index + 1 + this.tableLength}</td>
                <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${!el.townName ? '/' : el.townName}</td>
                <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${!el.stationInfo || el.stationInfo.indexOf('null') !== -1 ? '/' : el.stationInfo}</td>
                <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${!el.value ? '0' : el.value}</td>
              </tr>
            `
            })
            if (this.townList.length % 2 !== 0) {
              this.townListFrameRight += `
               <tr >
                <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${this.townList.length + 1}</td>
                <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;"></td>
                <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;"></td>
                <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;"></td>
              </tr>
            `
            }
            // 水位情况表格拼接
            if (this.riverList.length % 2 === 0) {
              this.waterLevelLength = this.riverList.length / 2
            } else {
              this.waterLevelLength = Math.ceil(this.riverList.length / 2)
            }
            this.riverList.slice(0, this.waterLevelLength).forEach((el, index) => { // 截取表格前半部分
              this.riverListFrameLeft += `
            <tr >
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${!el.stnm ? '/' : el.stnm}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${!el.value ? '/' : el.value}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${!el.diffValue ? '/' : el.diffValue}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${!el.diffWarn ? '/' : el.diffWarn}</td>
            </tr>
            `
            })
            this.riverList.slice(this.waterLevelLength, this.waterLevelLength * 2).forEach((el, index) => { // 截取表格后半部分
              this.riverListFrameRight += `
               <tr>
                <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${!el.stnm ? '/' : el.stnm}</td>
                <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${!el.value ? '/' : el.value}</td>
                <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${!el.diffValue ? '/' : el.diffValue}</td>
                <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${!el.diffWarn ? '/' : el.diffWarn}</td>
              </tr>
            `
            })
            if (this.riverList.length % 2 !== 0) {
              this.riverListFrameRight += `
               <tr >
                <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;"></td>
                <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;"></td>
                <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;"></td>
                <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;"></td>
              </tr>
            `
            }
            // 水库蓄水情况
            // 小型水库
            this.smallReservoirFrame += ` 
          <tr style="background: white;">
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;"rowspan="2">小型水库</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;"colspan="3" rowspan="1">库容（万m³)</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${this.smallReservoirList.length > 0 ? this.smallReservoirList[0].value : '/'}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${this.smallReservoirList.length > 0 ? this.smallReservoirList[0].warnValue : '/'}</td>
            </tr>
            `
            for (let i = 1; i < this.smallReservoirList.length; i++) { // 小一型
              this.smallReservoirFrame += ` <tr style="background: white;">
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;"colspan="3" rowspan="1">平均蓄水率（%)</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${this.smallReservoirList.length > 0 ? this.smallReservoirList[i].value : '/'}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${this.smallReservoirList.length > 0 ? this.smallReservoirList[i].warnValue : '/'}</td>
            </tr>`
            }
            // 中型水库
            this.middleReservoirFrame += ` 
           <tr style="background: white;">
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;" rowspan="6">中型水库</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;" colspan="2" rowspan="3" >北溪水库</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">水位（m）</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${this.middleReservoirList.length > 0 ? this.middleReservoirList[0].value : '/'}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${this.middleReservoirList.length > 0 ? this.middleReservoirList[0].warnValue : '/'}</td>
            </tr>
            `
            this.middleReservoirFrame += ` 
            <tr style="background: white;">
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;" >库容（万m³）</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${this.middleReservoirList.length > 1 ? this.middleReservoirList[1].value : '/'}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${this.middleReservoirList.length > 1 ? this.middleReservoirList[1].warnValue : '/'}</td>
            </tr>
            `
            this.middleReservoirFrame += ` 
            <tr style="background: white;">
              <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">蓄水率（%）</td>
              <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${this.middleReservoirList.length > 2 ? this.middleReservoirList[2].value : '/'}</td>
              <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${this.middleReservoirList.length > 2 ? this.middleReservoirList[2].warnValue : '/'}</td>
            </tr>
            `
            this.middleReservoirFrame += ` 
           <tr style="background: white;">
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;" colspan="2" rowspan="3" >金溪水库</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">水位（m）</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${this.middleReservoirList.length > 3 ? this.middleReservoirList[3].value : '/'}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${this.middleReservoirList.length > 3 ? this.middleReservoirList[3].warnValue : '/'}</td>
            </tr>
            `
            this.middleReservoirFrame += ` 
            <tr style="background: white;">
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">库容（万m³）</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${this.middleReservoirList.length > 4 ? this.middleReservoirList[4].value : '/'}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${this.middleReservoirList.length > 4 ? this.middleReservoirList[4].warnValue : '/'}</td>
            </tr>
            `
            this.middleReservoirFrame += ` 
            <tr style="background: white;">
              <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">蓄水率（%）</td>
              <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${this.middleReservoirList.length > 5 ? this.middleReservoirList[5].value : '/'}</td>
              <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${this.middleReservoirList.length > 5 ? this.middleReservoirList[5].warnValue : '/'}</td>
            </tr>
            `
            // 大型水库
            this.totalReservoirFrame += ` 
           <tr style="background: white;">
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;" rowspan="${this.totalReservoirList.length}">总体情况</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;" colspan="3" rowspan="1">库容（万m³)</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${this.totalReservoirList.length > 0 ? this.totalReservoirList[0].value : '/'}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${this.totalReservoirList.length > 0 ? this.totalReservoirList[0].warnValue : '/'}</td>
            </tr>
            `
            this.totalReservoirFrame += ` <tr style="background: white;">
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;" colspan="3" rowspan="1">平均蓄水率（%)</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${this.totalReservoirList.length > 1 ? this.totalReservoirList[1].value : '/'}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${this.totalReservoirList.length > 1 ? this.totalReservoirList[1].warnValue : '/'}</td>
            </tr>`
            this.totalReservoirFrame += ` <tr style="background: white;">
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;" colspan="3" rowspan="1">可拦蓄水量（万m³）</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${this.totalReservoirList.length > 2 ? this.totalReservoirList[2].value : '/'}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${this.totalReservoirList.length > 2 ? this.totalReservoirList[2].warnValue : '/'}</td>
            </tr>`
            this.totalReservoirFrame += ` <tr style="background: white;">
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;" colspan="3" rowspan="1">可调节库容（万m³）</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${this.totalReservoirList.length > 3 ? this.totalReservoirList[3].value : '/'}</td>
            <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${this.totalReservoirList.length > 3 ? this.totalReservoirList[3].warnValue : '/'}</td>
            </tr>`
            // 建议
            this.nextText.forEach(el => {
              this.nextTextFrame += `  <p style="font-size: 14pt; margin-top: -5px; text-indent: 25px;">${el}</p>`
            })
            // this.reservoirInfo.forEach(el => {
            //   this.reservoirInfoFrame += ` <p style="font-size: 14pt; margin-top: -5px; text-indent: 25px;">${el}</p>`
            // })
            this.loading = false
            this.getShowDataTr()
          }
        })
    },
    // 转换图片为 base64 (todo: 有可能因跨域报错)
    convertImagesToBase64 (contentDocument) {
      // 找到所有的图片
      let imgs = contentDocument.querySelectorAll('img')
      // 图片转换用
      let canvas = document.createElement('canvas')
      let ctx = canvas.getContext('2d')
      imgs.forEach((img, i) => {
        if (img.src.startsWith('data:image')) return
        // img表现尺寸
        let realWidth = parseInt(img.style.width)
        let realHeight = parseInt(img.style.height)

        // 清空画布并调整为 img 的大小
        ctx.clearRect(0, 0, canvas.width, canvas.height)
        canvas.width = realWidth
        canvas.height = realHeight
        // 画图片到画布
        ctx.drawImage(
          img,
          0,
          0,
          img.width,
          img.height,
          0,
          0,
          realWidth,
          realHeight
        )
        // ctx.drawImage(img, 0, 0);

        // 画布转为 base64
        let dataURL = canvas.toDataURL()
        img.setAttribute('src', dataURL)
      })

      canvas.remove()
    },
    convertChartsToBase64 (contentDocument) {
      // 找到所有的图表 （echart）
      let canvases = contentDocument.querySelectorAll('canvas')
      // 遍历图表，转换为 base64 静态图片
      canvases.forEach((canvas, i) => {
        let echart = this.$refs.chart[i]
        let url = echart.getDataURL()
        let img = document.createElement('img')
        img.src = url
        canvas.parentNode.replaceChild(img, canvas)
      })
    },
    // 生成下载链接
    createDownloadLink (fileObj, fileName) {
      let link = document.createElement('a')
      link.href = URL.createObjectURL(fileObj)
      link.download = fileName || 'document.docx'
      link.appendChild(document.createTextNode(''))
      return link
    },
    exportDocx () {
      // 获取页面dom元素
      let contentDocument = this.tinymceHtml
      let content = `<!DOCTYPE html>
            <head>
                <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
                 <style>
                 <style>
            </head>
            <body>
                ${contentDocument}
            </body>
            </html>`
      let converted = htmlDocx.asBlob(content)
      saveAs(converted, '水雨情日报.docx')
      let link = this.createDownloadLink(converted, '水雨情日报.docx')
      this.$refs.downloadArea.innerHTML = ''
      this.$refs.downloadArea.appendChild(link)
    }
  },
  created () {
    let myDate = new Date()
    this.currentYear = myDate.getFullYear()
    this.titleTime = myDate.getFullYear() + '年' + (myDate.getMonth() + 1) + '月' + myDate.getDate() + '日'
    this.showTime = (myDate.getMonth() + 1) + '月' + myDate.getDate() + '日' + myDate.getHours() + ':' + (myDate.getMinutes() > 9 ? myDate.getMinutes() : '0' + myDate.getMinutes())
  },
  mounted () {
    tinymce.init({})
    this.chooseTime()
    this.tabledata()
    this.$nextTick(() => {
      let contentDiv = document.getElementsByClassName('content')
      this.$refs['yuliang'].style.height =
        contentDiv[0].offsetHeight - 30 + 'px'
      let selectHeight = this.$refs.districtrainOperation.offsetHeight
      this.$refs.tableDiv.style.height = this.$refs.yuliang.offsetHeight - selectHeight - 30 + 'px'
    })
  }
}
</script>
<style lang="less" src="@/assets/monitor.less" scoped>
</style>
<style lang="less" scoped>
.yuliang {
   /deep/ .tableDiv{
      margin-top: 15Px;
      width:98%;
      margin-left: 1%;
      overflow: auto;
      padding-top: 10px;
    }
}
</style>
